











import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DropDown extends Vue {

    @Prop({ default: 220 }) contentMinWidth: number;

    opened = false;

    mounted() {
        document.addEventListener('click', this.clickOutsideHandler);
    }

    clickOutsideHandler(event: Event) {
        if(this.opened) {
            const dropDownElement = this.$refs.dropDown as HTMLElement;
            const titleElement = this.$refs.title as HTMLElement;
            const target = event.target as HTMLElement

            const isClickInside = dropDownElement.contains(target) || titleElement.contains(target);

            if(!isClickInside) {
                this.opened = false;
            }
        }
    }

    beforeDestroy() {
        document.removeEventListener('click', this.clickOutsideHandler);
    }
}
